import React from 'react';
import { Col, Icon, Row } from 'straightline-ui';
import { formatMoney, formatNumber } from 'straightline-utils/accounting';
import { truckType } from 'straightline-utils/constants';

export function ShipmentBanner({ shipment, amount }) {
  return (
    <Row className="justify-content-between align-items-center mb-n2">
      <Col xs="auto" className="mb-2">
        {amount ? (
          <div className="d-flex">
            <del
              className="h1 mb-0 text-primary mr-3"
              style={{ fontSize: 35, lineHeight: 1, opacity: 0.65 }}
            >
              {formatMoney(shipment.rate.price.carrier_price, {
                precision: 0
              })}
            </del>
            <div
              className="h1 mb-0 text-primary"
              style={{ fontSize: 35, lineHeight: 1 }}
            >
              {formatMoney(amount, {
                precision: 0
              })}
            </div>
          </div>
        ) : (
          <div
            className="h1 mb-0 text-primary"
            style={{ fontSize: 35, lineHeight: 1 }}
          >
            {formatMoney(shipment.rate.price.carrier_price, { precision: 0 })}
          </div>
        )}
      </Col>
      <Col xs="auto" className="text-right mb-2">
        <div className="text-secondary">
          {shipment.truck.label}
          {shipment.load_weight && (
            <React.Fragment>
              <span className="text-muted"> &#9679; </span>
              {`${
                shipment.load_weight >= 1000
                  ? (shipment.load_weight / 1000).toFixed(1) + 'k'
                  : shipment.load_weight.toFixed()
              } lbs`}
            </React.Fragment>
          )}
        </div>
        <div className="text-secondary">
          {shipment.travel.miles} mi
          <span className="text-muted"> &#9679; </span>
          {formatMoney(
            (
              (amount || shipment.rate.price.carrier_price) /
              (shipment.travel.miles || 1)
            ).toFixed(1)
          )}
          /mi
        </div>
      </Col>
    </Row>
  );
}

export const ShipmentUnits = ({ shipment }) => {
  const units = shipment.line_items.reduce((units, item) => {
    return units + item.units;
  }, 0);
  return (
    <div>
      <div className="d-flex align-items-center">
        <Icon type="truck" className="text-secondary mr-1" />
        <span className="mr-3">{truckType(shipment.truck_type).label}</span>
        <Icon type="list" className="text-secondary mr-1" />
        <span className="mr-3">
          {formatNumber(shipment.accessorial_codes?.length || 0)} accs
        </span>
      </div>
      <div className="d-flex align-items-center">
        <Icon type="inbox" className="text-secondary mr-1" />
        <span className="mr-3">{formatNumber(units)} units</span>
        <Icon type="anchor" className="text-secondary mr-1" />
        <span className="mr-3">{formatNumber(shipment.load_weight)} lbs</span>
        <Icon type="map" className="text-secondary mr-1" />
        <span className="mr-3">{formatNumber(shipment.travel.miles)} mi</span>
      </div>
    </div>
  );
};

export const ShipmentCost = ({ shipment }) => {
  return (
    <div>
      <div className="d-flex align-items-center">
        <Icon type="truck" className="text-secondary mr-1" />
        <span className="mr-3">
          {formatMoney(shipment.rate.price.carrier_price)}
        </span>
        <Icon type="map" className="text-secondary mr-1" />
        <span className="mr-3">
          {formatMoney(
            shipment.rate.price.carrier_price /
              Math.max(shipment.travel.miles, 1)
          )}
          /mi
        </span>
        <Icon type="anchor" className="text-secondary mr-1" />
        <span className="mr-3">
          {formatMoney(
            shipment.rate.price.carrier_price / shipment.load_weight
          )}
          /lb
        </span>
      </div>
    </div>
  );
};
